import { Injectable, Inject } from "@angular/core";
import { ReplaySubject } from "rxjs";
import { AuthTokenService } from "./auth-token.service";
import { UserService } from "./user.service";
import { Router } from "@angular/router";
import { Authathenticate } from "../models/authAuthenticate";
import { Site } from "app/models/site";
import { CookieService } from "ngx-cookie-service";
/**
 * This class provides the Session Service to set / reset block ui event.
 */
@Injectable()
export class SessionService {
  private user: Authathenticate = new Authathenticate();
  sessionEvent$ = new ReplaySubject<Authathenticate>(1);
  private siteKey = "Depots";
  private siteIdKey = "DepotId";
  private userNameKey = "user_name";
  private sites: Site[];
  private userName: any;
  constructor(
    private authService: AuthTokenService,
    private cookieService: CookieService,
    private userService: UserService,
    private router: Router
  ) {
    if (authService.hasToken()) {
      this.getUserInfo(false);
    } else {
      this.notify();
    }
  }
  /**
   * Mark user authenticated and brodcast user object via sessionEvent
   * @param {User} user - user object
   * @authenicated
   */
  public authenicated(token: any, sites: Site[], userName: any): void {
    this.authService.setToken(token);
    this.setSites(sites);
    console.log(sites);
    this.getUserInfo(true);
    this.userName = userName;
    localStorage.setItem(this.userNameKey, userName);
    //this.notify();
  }
  private getUserInfo(isblock) {
    //console.log("sajeel")
    this.user.userAuthenticate = true;
    this.notify();
  }
  getSites(): Site[] {
    if (this.sites == null && this.cookieService.get(this.siteKey) != "") {
      const site = this.cookieService.get(this.siteKey);
      //console.log("Sites from Cookies:" + site);
      this.sites = JSON.parse(site);
    }
    //console.log("out site if get Sites : " + this.cookieService.get(this.siteKey));
    return JSON.parse(localStorage.getItem(this.siteKey));
  }
  setSites(sites: Site[]): void {
    const strSites = JSON.stringify(sites);
    localStorage.setItem(this.siteKey, strSites);
    // console.log("SetSites:" + strSites);
    // if (typeof (Storage) !== "undefined") {
    //     console.log("Inside If");
    //     this.cookieService.set(this.siteKey,strSites, 1);

    //     this.sites = sites;
    // }

    //console.log("outsite if");
  }
  public getUserName(): any {
    if (
      this.userName == null &&
      this.cookieService.get(this.userNameKey) != ""
    ) {
      const userNameTemp = this.cookieService.get(this.userNameKey);
      //console.log("Sites from Cookies:" + site);
      this.userName = userNameTemp;
    }
    //console.log("out site if get Sites : " + this.cookieService.get(this.siteKey));
    return localStorage.getItem(this.userNameKey);
  }

  public getUserObject(): any {
    const user = this.cookieService.get("User");
    if(user === ""){
      this.router.navigate(["/login"]);
    }
    return JSON.parse(user);
  }

  getSiteId(): number {
    return JSON.parse(localStorage.getItem(this.siteIdKey));
  }
  setSiteId(siteId: any): void {
    const strSites = JSON.stringify(siteId);
    localStorage.setItem(this.siteIdKey, strSites);
  }

  public logout(): void {
    this.user = new Authathenticate();
    this.user.userAuthenticate = false;
    this.authService.clearToken();
    //localStorage.delete(this.siteKey);
    //console.log(this.user.userAuthenticate);
    localStorage.removeItem(this.siteIdKey);
    localStorage.removeItem(this.siteKey);
    this.notify();
  }
  private notify() {
    //console.log("user here",this.user)
    if (this.user.userAuthenticate == true) {
      this.router.navigate(["/dashboard"]);
    }
    this.sessionEvent$.next(this.user);
    //console.log("Session Event",this.sessionEvent$)
  }
}
